module.exports = __webpack_public_path__ + "static/media/hd-buttercup-large.ae7cb8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/hd-buttercup-large.png
// module id = 827
// module chunks = 27